export default __webpack_public_path__ + "static/media/element5-digital-OyCl7Y4y0Bk-unsplash.2fe8300b.jpg";